import React from "react";
import "./About.css";

// Import local images

import img24 from "./img24.jpg";
import img2 from "./kesar kajukatli.png";
import img1 from "./gulab jamun.png";

function About() {
  const sweets = [
    {
      name: "Gulab Jamun",
      image: img1,
      story:
        "Gulab Jamun is a festive favorite made from khoya and soaked in cardamom-infused rose syrup.",
      recipe:
        "Prepare a smooth dough by mixing khoya (or milk powder) with a little flour, shape the dough into small balls, deep-fry them until golden brown, and then soak the fried balls in warm, fragrant sugar syrup infused with cardamom and rose water until they become soft and juicy."
    },
    {
      name: "Kaju Katli",
      image: img2,
      story:
        "This cashew delight is known for its melt-in-the-mouth texture and is often gifted during Diwali.",
      recipe:
        " Grind cashews into a fine powder, then cook them with sugar syrup on low heat until the mixture thickens and comes together. Spread the dough onto a greased surface, roll it out evenly, and cut into diamond-shaped pieces once slightly cooled and firm."
    },
    {
      name: "Rasgulla",
      image: img24,
      story:
        "A Bengali classic, Rasgulla is light, spongy, and soaks up delicious syrup.",
      recipe:
        "Start by curdling fresh milk to make chenna (Indian cottage cheese), then knead it gently until smooth. Roll the chenna into small balls and boil them in a light sugar syrup until they puff up and become spongy, absorbing the sweet syrup for a soft, juicy texture."
    },
    
  ];

  return (
    <div className="about-container">
      {/* Shop Story */}
      <section className="shop-story fade-in">
        <h1>Our Story</h1>

        <p>
          Shiv Shakti Sweets and Farsan was established in the year 1988 in Mumbai, India. We are the best exporter and trader of ghee laddoo, katli sweets, dry fruit sweets and a lot more.  
           We believe that food serves our body the best when consumed in its original state of health. With our state-of-the-art technology, we preserve the natural taste of every product without adding any preservatives or synthetic colours.   Our team is headed by passionate people seasoned with decades of experience. And we collectively strive to be a global benchmark in product innovation, quality, freshness and commitment to excellence as; not just for business but for the people and the planet.
        </p>
        
        <p>  
             We partner with our clients to grow relationships based on trust. Our approach is always proactive and personal to understand the needs of the customers and thereby always deliver the right product at the right price.   Being strongly rooted in India, we have successfully branched out to far and wide corners of the world.   The variety of our products helps us cater to the diverse demands within the global market. And while we scale, our dedication only grows to innovate, restore and enhance the quality of what we deliver.   Our Mission   Shiv Shakti Sweets and Farsan uses innovation to respect and restore the bounty of nature by supplying it with the best state of health. We lead the way with people, forging trust through our farmers and them being the stewards of our quality.
        </p> 
        <p>

          COMPANY FACTS
          Ownership 
          Individual (Sole proprietorship)

          Year of Estd 
          1988

          Annual Turnover 
          Below Rs. 0.5 Crore Approx.
        </p>

         <h2>
          Looking like others...! our love for all our customers and making sweets makes us different. 
        </h2>

      </section>

      {/* Sweets Gallery */}
      <section className="sweets-gallery fade-in">
        <h2>Our Signature Sweets & Their Recipe</h2>
        <div className="sweets-grid">
          {sweets.map((sweet, index) => (
            <div key={index} className="sweet-card slide-up">
              <img src={sweet.image} alt={sweet.name} />
              <h3>{sweet.name}</h3>
              <p className="sweet-story">{sweet.story}</p>
              <details>
                <summary>View Recipe</summary>
                <p>{sweet.recipe}</p>
              </details>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;
